import React from "react";
import { Divider } from "antd";

export const DividerComponent = () => {
  return <Divider style={{ marginTop: 40, marginBottom: 40 }} />;
};
